<template>
  <div class="parties">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <PartiesTable @create-party="onCreateParty" @edit-party="onEditParty" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import PartiesTable from '@/components/Parties/PartiesTable';

export default {
  name: 'Parties',
  components: {
    Breadcrumbs,
    PartiesTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('parties') }];
    },
  },
  methods: {
    onCreateParty() {
      this.$router.push({ name: 'PartyCreatePage' });
    },
    onEditParty(party) {
      this.$router.push({
        name: 'PartyEditPage',
        params: { partyNumber: party.number },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
